import type { ServicesType } from './types';

let endpoints: ServicesType;
let googleMapsAPIKey: string;
let reAuthUrl: ServicesType['reAuthUrl'];
/**
 * To initialize endpoints base config
 * @param services response - {
        "data-end-point": "api/v1/stream/data",
        "action-end-point": "api/v1/stream/action",
        "base-server": "http://localhost:8080/prweb/"
    }
*/
const init = (services?: ServicesType) => {
  if (!services) {
    return;
  }

  services = services || {
    'base-server': 'http://localhost:1080/prweb/',
    'data-end-point': 'api/v1/stream/data',
    'action-end-point': 'api/v1/stream/action'
  };
  endpoints = services;
  endpoints.BASEURL = services.server;
  endpoints.ACTIONURL = services['action-end-point'];
  endpoints.DATAURL = services['data-end-point'];
  reAuthUrl = services.reAuthUrl;
};

/**
 * Would be called to form action url
 * @param action - The sample action would be CREATE_WORK. Should return http://localhost:8080/prweb/api/v1/creatework
 */
const getAPIURL = (action: keyof ServicesType) => {
  return `${endpoints.BASEURL}${endpoints[action]}`;
};

const getActionURL = () => {
  return `${endpoints.BASEURL}${endpoints.ACTIONURL}`;
};

const getServerURL = () => {
  return endpoints.BASEURL;
};

const getReAuthURL = () => {
  return reAuthUrl;
};

const getRouteURL = (action: keyof ServicesType) => {
  return endpoints[action];
};

const fetchData = (requestBody: any) => {
  return fetch(getActionURL(), {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  });
};

const setGoogleMapsAPIKey = (key: string) => {
  googleMapsAPIKey = key;
};

const getGoogleMapsAPIKey = () => {
  return googleMapsAPIKey;
};

export default {
  init,
  getAPIURL,
  getReAuthURL,
  getServerURL,
  getRouteURL,
  fetchData,
  setGoogleMapsAPIKey,
  getGoogleMapsAPIKey
};
